import { createEffect } from 'effector'

import { APIResult, AxiosError } from '../../core/api/Result'
import { DefaultsAPI } from '../../services/api/Defaults'

export const getDefaultsFx = createEffect<unknown, APIResult<typeof DefaultsAPI['getDefaults']>, AxiosError>(
  DefaultsAPI.getDefaults,
)
